import type { operations } from "@/lib/api/schema";
import { useQuery } from "@tanstack/react-query";
import { getCertificationsCount, getCertificationsList } from "./api";
import { certificationsKeys } from "./key";

/**
 * 資格件数取得用のhook
 */
export function useCertificationsCountQuery(
  params: Partial<
    NonNullable<
      operations["CertificationController_getCertificationsCount_v2"]["parameters"]["query"]
    >
  >,
) {
  return useQuery({
    queryKey: certificationsKeys.count(params),
    queryFn: () => getCertificationsCount(params),
  });
}

/**
 * 資格一覧取得用のhook
 */
export function useCertificationsQuery(
  params: Partial<
    NonNullable<
      operations["CertificationController_getCertifications_v2"]["parameters"]["query"]
    >
  >,
) {
  return useQuery({
    queryKey: certificationsKeys.list(params),
    queryFn: () => getCertificationsList(params),
  });
}
